import { Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";


export const Sent:React.FC<any>=React.memo((props)=>{

    const columns: IColumns[] = [
        
        {
            header: "Subject",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Date",
            fieldName: "address",
            tooltip: true,
        },
       
       
    ];
    return(
        <Grid container spacing={2}>
            <Grid item xs={12}>
            <WSDataGrid
                    id="itemGrid"
                    title=""
                    columns={columns}
                />
           </Grid>
        </Grid>
    )
})